import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import {UserResponse} from '../../common/services/user/user.model';
import {masterAddressUpdateDialogAction} from './../master-address-update-dialog/master-address-update-dialog.action';
import 'jquery-ui/ui/widgets/autocomplete';
import FamilyPlanService from '../famil-plan.service';
import { ManageContactsDeleteDialogAction } from '../manage-contacts-delete-dialog/manage-contacts-delete-dialog.action';
import { FamilyPlanMemberType } from '../family-plan.model';
import { ITimeoutService } from 'angular';
import { OpenAboutDialogAction } from '../family-plan-about-dialog/family-plan-about-dialog.action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class familPlanController {
  public user: UserResponse;
  public approveSaveCard: boolean = false;
  public copyToClipboardText: boolean = false;
  public membersRowHTML: string;
  public deleteIcon: any;
  public subMembersLength: any;
  public subMember = [];
  public subMembers = [];
  public subMembersParam: string;
  public subMembersParam2: string;
  public subMGenerateLinkToken: string;
  public subMGenerateLink:string;
  public newGeneratedToken: string;
  public fpInfoAddress:string;
  private addressChange: any;
  private type: FamilyPlanTypes;

  public selectedAddress: any;
  constructor(
    private $timeout: ITimeoutService,
    private config,
    private actionDispatcher: ActionDispatcherService,
    private familyPlanService: FamilyPlanService,
    private $state
  ) {

  }

  public $onInit() {
      this.subUsersCheck(); 
      angular.element(document).ready(() => {
      if(this.type == FamilyPlanTypes.FAMILY) {
        this.addressAutoComplete(); 
      }
    });
  }

  public addressAutoComplete(){
    this.addressChange = angular.element('#address');
    var self = this;
    self.autoComplete(self, ''); 
    this.addressChange.bind('paste keyup', function (evnt)  {
      self.$timeout(() => {
        let addressinputval =  evnt.target.value;
        self.autoComplete(self, addressinputval) , 500
      });
  });

    
  };

  private autoComplete(self: this, addressinputval: any) {
    return $("#address").autocomplete({
      source: function (request, response) {
        self.familyPlanService.addressAutoComplete(addressinputval).then(result => {
          response(result);
        });
      },
      create: function () {
      },
      select: function (event, ui) {
        let adress = [];
        for (let i = 0; i < 16; i++) {
          adress.push(ui.item[i]);
        }

        self.selectedAddress = adress;
        $("#address").val(ui.item[0]);
        return false;

      }
    })
      .data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li>")
          .append("<div class='crspointer'>" + item[0] + "</div>")
          .appendTo(ul);
      };
  }

  public subUsersCheck(){
    this.familyPlanService.getFamilyPlanInfo(this.type).then(result => {
      this.subMembersLength = result.subMembers.length;
      this.subMembers = result.subMembers;
      this.subMGenerateLinkToken = result.token;
      this.subMGenerateLink = (this.type == FamilyPlanTypes.FAMILY ? this.config.familyPlan.shareURL : this.config.duoPlan.shareURL) +  this.subMGenerateLinkToken;
      this.fpInfoAddress = result.masterMember.address;
    }).catch(e => {
      this.$state.go("myAccount");
    });
  };

  public generateShareLink(){
    this.subMGenerateLink="";
    this.familyPlanService.generateInvitationUrl(this.type).then(result => {
      this.subMGenerateLink = (this.type == FamilyPlanTypes.FAMILY ? this.config.familyPlan.shareURL : this.config.duoPlan.shareURL) + result;
    });
    
  }

  public deleteSubMember(id){
    this.actionDispatcher.dispatch(new ManageContactsDeleteDialogAction(id, this.type));
  }

  public copyToClipboard() {
        $("#shareLink").focus();
        $("#shareLink").select();
        this.copyToClipboardText = true;
        document.execCommand('copy');
        this.$timeout(() => {
          this.copyToClipboardText = false;
        }, 2000);
  }

  public fpInfoSavedInfos(){
    this.actionDispatcher.dispatch(new masterAddressUpdateDialogAction(this.selectedAddress, FamilyPlanMemberType.MASTER));
  }

  public onAbout(){
    this.actionDispatcher.dispatch(new OpenAboutDialogAction(this.type));
  }
  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-info/family-plan-info.controller.ts